// extracted by mini-css-extract-plugin
export default {"section-wrapper":"SectionWrapper_section-wrapper__+69OS","title":"SectionWrapper_title__wH45D"};